module.exports = __webpack_public_path__ + "static/media/Orcamentos4.b1998e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrcamentos/Orcamentos4.png
// module id = 2099
// module chunks = 0